var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "layout-card",
        {
          staticClass: "dashboard__my-activities-card",
          attrs: {
            isCustomizable: _vm.settings.isCustomizable,
            type: _vm.settings.context,
            error: _vm.error,
            loading: _vm.isLoadingPage || _vm.loading
          },
          on: {
            "hide-card": function($event) {
              return _vm.$emit("hide-card", "my_activities")
            },
            "edit-card": _vm.handleConfigDialog,
            "refresh-card": _vm.refreshActivities
          }
        },
        [
          _c("template", { slot: "title" }, [_vm._v(_vm._s(_vm.name))]),
          _vm._v(" "),
          _c(
            "template",
            { slot: "actions" },
            [
              _c("CompassLink", {
                attrs: {
                  label: _vm.$t.__(
                    "dashboard.cards.MyActivitiesCard.actions.go_activity_page"
                  ),
                  target: "_blank",
                  link: _vm.linkActivitiesPage
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          !_vm.isLoadingPage || !_vm.loading
            ? _c("ActivitiesListingTable", {
                attrs: { slot: "content", columns: _vm.defaultColumns },
                slot: "content"
              })
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }